import { Pipe, PipeTransform } from '@angular/core';
import { SelectOptionData } from '@mzic/mzic-interfaces';

@Pipe({
  name: 'concatNames',
  standalone: true,
})
export class ConcatNamesPipe implements PipeTransform {
  transform(values: SelectOptionData[], name: string): unknown {
    return values.length > 0 ? `${values.length} ${name}` : '';
  }
}
